import { Location, matchRoutes } from 'react-router-dom'

export const isCurrentLocationInPaths = (paths: string[], location: Location): boolean => {
  return matchRoutes(paths.map(e => { return { path: e }}), location)?.find(e => paths.includes(e.route.path)) != null
}